import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import './exam-review.scss'
import Notification from '../../elements/Notification/Notification.tsx'
import { getShareUrl } from '../../layout/ShareReview/ShareReviewHelper'
import ShareReview from '../../layout/ShareReview/ShareReview'
import NodeScore from '../../node/NodeScore/NodeScore'
import { getSeriesClassification } from '../../../redux/modules/series/selectors'
import RichTextContent from '../../misc/RichTextContent/RichTextContent'
import { fetchAverageScores } from '../../../redux/middleware/examService/examService'

const ExamReview = ({
  score,
  maxScore,
  review,
  exam,
  examId,
  seriesHideStats,
  onFetchAverageScores,
}) => {
  const showAverageScore =
    Boolean(exam.disable_saving) === false &&
    Boolean(seriesHideStats) === false &&
    Boolean(exam.hideScores) === false

  useEffect(() => {
    if (showAverageScore && !exam.averageScore) {
      onFetchAverageScores()
    }
  }, [showAverageScore, exam.averageScore, onFetchAverageScores])

  const calculatedAverageScore =
    exam.averageScore &&
    typeof exam.averageScore.average === 'number' &&
    typeof exam.averageScore.max_score === 'number'
      ? Math.round(exam.averageScore.average * 10) / 10
      : null

  const url = review ? getShareUrl(review.share, examId) : null
  const displayShare = exam.enableShare && url && review.share
  const hasReview = review && review.description

  return (
    <div className="yo-exam-review" data-testid="exam-review">
      <Notification>
        <div className="yo-node-review-notification-content">
          {hasReview && <RichTextContent content={review.description} />}
          <NodeScore
            hasScores
            maxScore={maxScore}
            nodeSettings={{}}
            score={score}
            titleKey="ExamReview:points"
          />
          {showAverageScore && calculatedAverageScore !== null && (
            <NodeScore
              hasScores
              maxScore={exam.averageScore.max_score}
              nodeSettings={{}}
              score={calculatedAverageScore}
              titleKey="ExamReview:average-score"
            />
          )}
        </div>
      </Notification>

      {displayShare && <ShareReview review={review} url={url} />}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    seriesHideStats: getSeriesClassification(state).hideStatistics,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onFetchAverageScores: () => {
      dispatch(fetchAverageScores(ownProps.examId))
    },
  }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ExamReview))
